import { redirect } from 'react-router-dom';
import { clearAuthToken } from '../util/auth.jsx'

export function action() {
  clearAuthToken();
  return redirect('/');
}

